export const ECONOMICS_STAMP = "THE ECONOMICS OF SCALING";

export const ECONOMICS_SCAN_LINE =
  "Same money in · More inspections out · Nobody new on payroll";

export const ECONOMICS_PILLARS = [
  {
    id: "spend",
    value: "SAME",
    suffix: "$",
    label: "Ad spend",
    detail: "Google Ads budget stays flat — no extra media spend",
    tone: "neutral",
  },
  {
    id: "output",
    value: "2×",
    suffix: null,
    label: "Booked inspections",
    detail: "Up to twice as many qualified appointments on the calendar",
    tone: "hero",
  },
  {
    id: "headcount",
    value: "0",
    suffix: null,
    label: "New hires",
    detail: "No dispatch, intake, or office staff added",
    tone: "neutral",
  },
];

export const ECONOMICS_PAYOFF = {
  lead: "Speed wins the leak emergency.",
  middle: "Protocol filters the noise.",
  close: "Your estimators only talk to prospects who are already vetted and booked.",
};

export const ECONOMICS_PROOF_STRIP = [
  { tag: "9 SEC", text: "Leak & inspection asks answered 24/7" },
  { tag: "VETTED", text: "Noise filtered before your team sees it" },
  { tag: "CLOSE", text: "Humans handle trust & the final contract" },
];
